import { AxiosProgressEvent } from 'axios';
import { uploadClient } from 'utils/upload/uploadClient';
import { LegacyUploadParams } from 'utils/upload/types';

export async function uploadLegacy(
  blob: Blob,
  fileName: string,
  params: LegacyUploadParams,
  signal: AbortSignal,
  onUploadProgress?: (event: AxiosProgressEvent) => void
): Promise<void> {
  const formData = new FormData();
  formData.append('file', blob, fileName);
  Object.entries(params.formFields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  await uploadClient.post(params.storageUrl, formData, {
    headers: { 'Secure-Token': params.token },
    signal,
    onUploadProgress,
  });
}
